import data from './data.json';


export default function foo() {
  return data;

}